import React from "react";

import { OnboardingHubUser } from "../../models/user";
import { CrmEntity, EntityName } from "../../server/crm/dataService";
import { TestDataAction } from "./TestDataAction";
import { TestDataEntry } from "./TestDataEntry";

type TestDataDisplayProps = Readonly<{
  userInfo?: OnboardingHubUser;
  gameConcepts?: CrmEntity<EntityName.gaming_gameconcept>[];
  pitchConcepts?: CrmEntity<EntityName.ggp_strike>[];
  contact?: CrmEntity<EntityName.contact>;
  account?: CrmEntity<EntityName.account>;
  onboardingHubProfile?: CrmEntity<EntityName.gaming_onboardinghubprofile>;
  onboarding?: CrmEntity<EntityName.gaming_onboarding>;
  idAzure?: CrmEntity<EntityName.gaming_idazure>;
  pitch?: CrmEntity<EntityName.gaming_pitchprogram>;
  ogcEnvURL?: string;
}>;

export const TestDataDisplay = ({
  userInfo,
  account,
  contact,
  onboardingHubProfile,
  onboarding,
  idAzure,
  pitch,
  ogcEnvURL,
}: TestDataDisplayProps) => (
  <div>
    <TestDataEntry header="Onboarding Id" text={`${userInfo?.emailAddress}`} />
    <TestDataEntry header="Account ID" text={`${account?.accountid}`} />
    <TestDataEntry header="Contact ID" text={`${contact?.contactid}`} />
    <TestDataEntry
      header="Onboarding Hub Profile ID"
      text={`${onboardingHubProfile?.gaming_onboardinghubprofileid}`}
    />
    <TestDataEntry header="Onboarding ID" text={`${onboarding?.gaming_onboardingid}`} />
    <TestDataEntry header="IdAzure ID" text={`${idAzure?.gaming_idazureid}`} />
    <TestDataEntry header="Pitch ID" text={`${pitch?.gaming_pitchprogramid}`} />
    <TestDataEntry header="Seller Id" text={`${account?.ggp_udcsellerid}`} />

    {account?.accountid && (
      <TestDataAction
        url={`${ogcEnvURL}&etn=account&id=${account.accountid}`}
        text="Open Account"
      />
    )}
    {contact?.contactid && (
      <TestDataAction
        url={`${ogcEnvURL}&etn=contact&id=${contact.contactid}`}
        text="Open Contact"
      />
    )}
    {onboardingHubProfile?.gaming_onboardinghubprofileid && (
      <TestDataAction
        url={`${ogcEnvURL}&etn=gaming_onboardinghubprofile&id=${onboardingHubProfile.gaming_onboardinghubprofileid}`}
        text="Open Onboarding Hub Profile"
      />
    )}
    {onboarding?.gaming_onboardingid && (
      <TestDataAction
        url={`${ogcEnvURL}&etn=gaming_onboarding&id=${onboarding.gaming_onboardingid}`}
        text="Open Onboarding"
      />
    )}
    {idAzure?.gaming_idazureid && (
      <TestDataAction
        url={`${ogcEnvURL}&etn=gaming_idazure&id=${idAzure.gaming_idazureid}`}
        text="Open ID Azure"
      />
    )}
    {pitch?.gaming_pitchprogramid && (
      <TestDataAction
        url={`${ogcEnvURL}&etn=gaming_pitchprogram&id=${pitch.gaming_pitchprogramid}`}
        text="Open Pitch"
      />
    )}
    <br />
    <br />
  </div>
);
